module.exports = __webpack_public_path__ + "static/img_dxsm.6ca9e52a.png";